
import React, { useState, startTransition } from "react";
import classes from "../information/Information.module.css";
import Options from "./Options";
import Avatar from "@mui/material/Avatar";
import Header from "./Header";
import Chart from "./Chart";
import Activity from "./Activity";
import Table from "./Table";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import Tags from "../Tags/Tags";
import { useEffect } from "react";
import GetUserData from "../../Network_Calls/userdata";
import _ from "lodash";
import axios from "axios";
import { config } from "../../Network_Calls/config";
import { useParams, useSearchParams } from "react-router-dom";
import { getCustomer } from "../Search/Network_Calls";
import Section from "../sections/Section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import checks from "../Collection/Collection.module.css";
 
import { getAllImplTag, modifyImplTags } from "./Network_Calls";
import { Store } from "react-notifications-component";
import MapView from "./MapView";
 
import ExploreJourneyDataView from "./ExploreJourneyDataView";
 
import { ToggleButton, ToggleButtonGroup, Menu, Box, Button, MenuItem} from "@mui/material";
import { useNavigate } from 'react-router-dom';

import InteractionChart from './InteractionChart';
import ActionPlan from "../Dossier/ActionPlan";
import { getDossierDetails } from "../Dossier/Network_call";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import CustomerEngagementTemplate from "../Engagetemp/CustomerEngagementTemplate";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});


const Information = () => {

  const navigate = useNavigate();
  const { journey_type } = useParams();
 
  const [alignment, setAlignment] = React.useState("journey_view");
  const [tag, setTag] = useState("All");
  const { implId, id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const myName = searchParams.get("name");
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const [data, setdata] = useState([]);
  const [search, setSearch] = useState("");
  const [text, setText] = useState(false);
  const [taggedKeyword, settaggedKeyword] = useState([]);
  const [userData, setUserData] = useState([]);
  const [userSources, setUserSources] = useState([]);
  const [err, setErr] = useState(false);
  const [options, setOptions] = useState([]);
  const [opt, setOpt] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [stages, setStage] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [availabetags, setAvailabletags] = useState([]);
  const [checkedValues, setCheckedValues] = useState({
    response: [],
  });

  const open = Boolean(anchorEl);
  const [saveBtn, setSaveBtn] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [initialEnabledTags, setInitialEnabledTags] = useState([]);
  const [openActionPlanModal, setOpenActionPlanModal] = useState(false);
  const [dossierData, setDossierData] = useState(null);
  const [dossierNotFound, setDossierNotFound] = useState(false);

  const fetchDossierData = async () => {
    try {
      const result = await getDossierDetails(implId, id);
      if (result.status === 200) {
        let data = result.data;
        if (data.error === "Dossier not found") {
          setDossierNotFound(true);
        } else {
          setDossierData(data);
        }
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Error fetching dossier details: ", error);
      setErr(true);
    }
  };

  useEffect(()=>{
    if (implId && id) {
      fetchDossierData();
    }
  },[implId, id]); 
 
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
 
  
  const TAGS = ["All", "Last60", "Last30", "First30", "First60"];
  const setTags = (item) => {
    settaggedKeyword([...item]);
  };
 
  const selectedTag = (el) => {
    setTag(el);
  };
 
  const selectedSourceOption = (options) => {
    setOptions(options);
  };
  
  const getStages = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/customer/stages`,
        {
          impl_id: implId,
        },
        {
          ...config(),
        }
      );
      const result = await response.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  };
 
  useEffect(() => {
    getStages()
      .then((data) => {
        setStage(data.list);
      })
      .catch((e) => console.log(e));
    getAllImplTag(implId, id)
      .then((x) => {
        setAvailabletags(x.data.tagList);
        setInitialEnabledTags(
          x.data.tagList.filter((tag) => tag.enabled).map((tag) => tag.tag_name)
        );
      })
      .catch((e) => console.log(e));
  }, []);
 
 
  useEffect(() => {
    if (options.length !== 0) {
    
      const filter = userData.filter((obj) => options.includes(obj.sources));
      if (tag && tag === "First60") {
        const tagFiltered = filter.slice(-60);

        setFilteredData(tagFiltered);
      } else if (tag === "First30") {
        const tagFiltered = filter.slice(-30);
 
        setFilteredData(tagFiltered);
      } else if (tag === "Last60") {
        const tagFiltered = filter.slice(0, 60);
 
        setFilteredData(tagFiltered);
      } else if (tag === "Last30") {
        const tagFiltered = filter.slice(0, 30);
 
        setFilteredData(tagFiltered);
      } else if (tag === "All" || tag === "") {
        setFilteredData(filter);
      }

    }

    if (implId && id) {
      fetchDossierData();
    }

    
  }, [tag, options]);
 
  useEffect(() => {
    
    const user = async () => {
      const result = await getCustomer(implId, id, journey_type);
      if (result.status === 200) {
        const { users, sources } = result.data;
        setUserData(users);
        setLoading(false);
        setUserSources(sources);
        setFilteredData(users);
      } else {
        setErr(true);
      }
    };
    user();

    
 
    const get_data = async () => {
      try {
        const data = await GetUserData();
        setProfile(data.data.data);
        setdata(data.data.info);
      } catch (error) {
        console.log(error);
      }
    };
    
  }, []);
 
  const postTag = async (search) => {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/user/tags",
      { tag: search },
      { ...config }
    );
    const data = await response.data;
 
    if ((data.msg = "Tags added Successfully")) {
      setdata((prev) => {
       
        return {
          info: prev.info,
          tags: [search, ...prev.tags],
        };
      });
    }
  };
 
  const selectHandler = () => {
    if (search) {
      const request = postTag(search);
    
    }
    setSearch("");
    setText(false);
  };
 
  const textCloseHandler = () => {
    setText(false);
  };
 
  let newFilterArray = data.data || [];
 
  if (taggedKeyword.length !== 0) {
    var arr1 = data.data,
      arr2 = taggedKeyword;
    let res = arr1.filter((item) => {
      if (
        arr2.includes(item.source) ||
        arr2.includes(item.journey_stage) ||
        arr2.includes(item.contact) ||
        arr2.includes(item.status) ||
        arr2.includes(item.tag1) ||
        arr2.includes(item.tag2) ||
        arr2.includes(item.tag3)
      ) {
        return item;
      }
    });
 
    newFilterArray = [...res];
  }
 
 
 
  if (search !== "" && newFilterArray.length !== 0) {
   
    newFilterArray = newFilterArray.filter((x) => {
      if (Object.values(x).toString().search(_.capitalize(search)) >= 0) {
        return x;
      }
    });
  }
 
  const tagDelete = () => {
   
  };
  
  const chartData = [...filteredData].reverse();

 
  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
 
  const handleChangeInputCheckBox = (e) => {
    const { value } = checkedValues;
    const tagArray = availabetags.map((x) => {
      if (e.target.value === x.tag_name) {
        return {
          ...x,
          enabled: !x.enabled,
        };
      } else {
        return {
          ...x,
        };
      }
    });
    setAvailabletags(tagArray);
  };
 
  const handleSaveTagDetails = async (req, res) => {
    setSaveBtn(true);
    const info = await modifyImplTags(implId, id, availabetags)
      .then((x) => {
        setAvailabletags(x.data.tagList);
        handleClose();
        addNotification();
        setSaveBtn(false);
      })
      .catch((e) => console.log(e));
  };
 
  const addNotification = async () => {
    await Store.addNotification({
      title: "Tag Modified",
      message:
        "The data associated with a specific customer tag has undergone modifications.",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true,
      },
    });

    const updatedInitialEnabledTags = [...availabetags]
      .filter((tag) => tag.enabled)
      .map((tag) => tag.tag_name);
    setInitialEnabledTags(updatedInitialEnabledTags);
    setCardData(filteredData);
  };
 
  const handleGoBack = () => {
    startTransition(() => {
      navigate('/user/findcontact/' + journey_type);
    });
  };
 
  const handleGoToDossier = () => {
    navigate('/user/'+journey_type+'/dossiercheck?name='+myName+'&&impl_id='+implId+'&&id='+id);
  };

 
  return (
    <>
      <Navbar />

      <Box sx={{ display: "flex", gap: 2, ml: 5, mt: 3 }}>
        <Button variant="contained" color="primary" onClick={handleGoBack}>
          Back
        </Button>
        <Button variant="contained" color="primary" onClick={handleGoToDossier}>
          Go To Dossier
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenActionPlanModal(true)}
        >
          View Action Plan
        </Button>
        <Dialog
          open={openActionPlanModal}
          onClose={() => setOpenActionPlanModal(false)}
          fullWidth
          maxWidth="md"
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              position: "absolute",
              right: 0,
              bottom: 0,
              top: 0,
              maxHeight: "100vh",
              overflow: "hidden",
              width: "32rem",
              height: "100vh",
              marginTop: "0rem",
              marginRight: "0rem",
              borderRadius: "0rem",
            },
          }}
        >
          <DialogContent>
            <ActionPlan
              dossierData={dossierData}
              refreshDossierDetails={fetchDossierData}
            />
          </DialogContent>
          <DialogActions>
            <FontAwesomeIcon
              icon={faXmark}
              onClick={() => setOpenActionPlanModal(false)}
              style={{
                position: "absolute",
                right: "2rem",
                top: "3rem",
                fontSize: "1.5rem",
              }}
            />
          </DialogActions>
        </Dialog>
      </Box>

      <div className={classes.container}>
        {!loading && userData.length !== 0 ? (
          <div className={classes.tag}>
            <Tags tag={TAGS ? TAGS : []} onSelect={selectedTag} />
          </div>
        ) : (
          ""
        )}

        <div className={classes.main}>
          {!loading && userData.length !== 0 ? (
            <div className={classes.options}>
              <Options
                optionSelection={selectedSourceOption}
                data={userSources}
              />
            </div>
          ) : (
            ""
          )}

          {loading ? (
            <p className={classes.loader}>
              <span className={classes.spinner}></span>
              <span>Loading...</span>
            </p>
          ) : userData.length !== 0 ? (
            <>
              <div className={classes.middle}>
                <div className={classes.headerContainer}>
                  <div className={classes.name}>
                    <Avatar
                      sx={{
                        border: "5px solid #64c8d5",
                        height: "3em",
                        width: "3em",
                        boxShadow: " 5px 5px 30px #ceb6b6",
                      }}
                      alt="avatar"
                      src="https://cdn-icons-png.flaticon.com/512/6522/6522516.png"
                    />
                    <h2 style={{ overflow: "hidden" }}>{myName}</h2>
                  </div>
                  <div style={{ margin: "auto" }}>
                    <Header data={userData} />
                  </div>
                </div>
                <div style={{ flex: "1", margin: "auto" }}>
                  <Activity data={filteredData} />
                </div>
              </div>

              <div className={classes.chartContainer}>
                <Chart data={chartData} />
              </div>
              <br />

              <div className={classes.chartContainer}>
                <InteractionChart data={userData} />
              </div>

              {/* cards */}
              <br />
              <br />
              <br />
              <div
                className={checks.tags}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {initialEnabledTags.map((tagName) => (
                  <>
                    <div className={checks.mainBox}>
                      <div
                        className={checks.active}
                        style={{
                          color: "white",
                          backgroundColor: "black",
                        }}
                      >
                        <label
                          type="text"
                          value={tagName}
                          checked={
                            availabetags.find((tag) => tag.tag_name === tagName)
                              .enabled
                          }
                        />
                        <div>{tagName}</div>
                      </div>
                    </div>
                  </>
                ))}
              </div>

              <div
                style={{
                  backgroundColor: "#F3F8FF",
                  display: "flex",
                  padding: "32px 70px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "0px",
                }}
              >
                {" "}
                <div>
                  <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleChange}
                    aria-label="Platform"
                  >
                    <ToggleButton value="journey_view">
                      Journey View
                    </ToggleButton>
                    {window.screen.width >= 768 ? (
                      <ToggleButton value="table_view">Table view</ToggleButton>
                    ) : (
                      <></>
                    )}
                    <ToggleButton value="map_view">Timeline View</ToggleButton>
                    <ToggleButton value="explore_journey_data">
                      Explore Journey Data
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div
                  style={{
                    display: availabetags.length !== 0 ? "block" : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                      size="2xl"
                      icon={faEllipsis}
                      fade
                    />
                    <p style={{ color: "grey", fontSize: "0.75rem" }}>
                      Modify your Tags
                    </p>
                  </div>

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {availabetags.map((data, index) => (
                      <MenuItem key={index}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <input
                              type="checkbox"
                              value={data.tag_name}
                              checked={data.enabled}
                              onChange={handleChangeInputCheckBox}
                              check
                            />
                          </div>
                          <div>{data.tag_name}</div>
                        </div>
                      </MenuItem>
                    ))}
                    <MenuItem
                      style={{ color: "green", fontWeight: "lighter" }}
                      onClick={handleSaveTagDetails}
                      disabled={saveBtn}
                    >
                      Save
                    </MenuItem>
                    <MenuItem
                      style={{ color: "red", fontWeight: "lighter" }}
                      onClick={handleClose}
                    >
                      Cancel
                    </MenuItem>
                  </Menu>
                  <div></div>
                </div>
              </div>

              {alignment === "table_view" ? (
                <div
                  style={{ backgroundColor: "#F3F8FF" }}
                  className={classes.table}
                >
                  {window.screen.width >= 768 ? (
                    <Table data={filteredData}  implId={implId} />
                  ) : (
                    <></>
                  )}
                </div>
              ) : alignment === "journey_view" ? (
                <div
                  style={{
                    display: "flex",
                    padding: "0px 70px",
                    justifyContent: "center",
                    backgroundColor: "#F3F8FF",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <Section users={filteredData} data={stages} />
                  </div>
                </div>
              ) : alignment === "map_view" ? (
                <div>
                  <MapView data={filteredData} />
                </div>
              ) : alignment === "explore_journey_data" ? (
                <div>
                  <ExploreJourneyDataView users={filteredData} data={stages} />
                </div>
              ) : (
                <></>
              )}
              <br></br>
              <div><CustomerEngagementTemplate  implId={implId} external_id={id}/></div>
            </>
          ) : (
            <p
              style={{
                textAlign: "center",
                marginTop: "70px",
                fontSize: "24px",
              }}
            >
              No <span style={{ color: "#ff762b" }}>Journey</span> for this{" "}
              <span style={{ color: "#00a0b2" }}>User</span>
            </p>
          )}
        </div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    </>
  );
};


export default Information;
 
